<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'app',
  components: {},
  beforeCreate() {
    this.$store.commit('setUrlParm', this.$route.query)
    this.$store.commit('setLangPath', this.$route.path)
    this.$store.dispatch('languages/fetchLanguage', this.$store.state.locale);
    this.$store.dispatch('articles/fetchArticles', this.$store.state.locale);
    this.$store.dispatch('articles/fetchFullArticles')
    this.$store.dispatch('messages/fetchMessages', { lg2: this.$store.state.lg2, locale: this.$store.state.locale });
    this.$store.dispatch('fetchCategories')
    this.$store.dispatch('createplusMessages/fetchMessages', { lg2: this.$store.state.lg2, locale: this.$store.state.locale });
    this.$store.dispatch('createplusTemplates/fetchTemplates', {locale: this.$store.state.locale, exe: this.$store.state.exe});

    if (this.$route.query.LOG == "OFF") {
      this.$gtag.optOut()
    }
  },
  metaInfo() {
    return {
      titleTemplate: '%s | ' + this.$store.state.messages.messages['0-140'] + ' ' + this.$store.state.messages.messages['0-149'],
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' }
      ],
      htmlAttrs: {
        lang: this.lang
      }
    }
  },
  computed: {
    lang: function() {
      if(this.$store.state.lg2 == 'c2') {
        return 'zh'
      }
      return this.$store.state.lg2
    }
  }
};


</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
